import { IOption } from '../models/ICommon';

export const permissionTypeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'View Only' },
  { id: 1, value: 'All Access' },
];

export const processType: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'Production', disabled: false },
  { id: 1, value: 'Testing', disabled: false },
  { id: 2, value: 'Print', disabled: false },
  { id: 3, value: 'Picking', disabled: false },
];

export const AccountStatusTypeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'Pending' },
  { id: 1, value: 'Active' },
];

export const FactoryTypeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Cell', disabled: false },
  { id: 1, value: 'Unit', disabled: false },
];

export const stepType: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Value' },
  { id: 1, value: 'Checkbox' },
];

export const blankOptions: IOption[] = [{ id: -1, value: '', disabled: true }];

export const FactoryTypeFilterOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'Cell', disabled: false },
  { id: 1, value: 'Unit', disabled: false },
];

export const WeekDaysOptions: IOption[] = [
  { id: -1, value: 'None', disabled: false },
  { id: 0, value: 'Sunday', disabled: false },
  { id: 1, value: 'Monday', disabled: false },
  { id: 2, value: 'Tuesday', disabled: false },
  { id: 3, value: 'Wednesday', disabled: false },
  { id: 4, value: 'Thursday', disabled: false },
  { id: 5, value: 'Friday', disabled: false },
  { id: 6, value: 'Saturday', disabled: false },
];

export const EventsOptions: IOption[] = [
  { id: -1, value: 'None', disabled: false },
  { id: 2, value: 'add', disabled: false },
  { id: 3, value: 'update', disabled: false },
  { id: 4, value: 'delete', disabled: false },
  { id: 13, value: 'import', disabled: false },
];

export const DIDAdminModuleOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'TenantManagement', disabled: false },
  { id: 1, value: 'UserManagement', disabled: false },
  { id: 2, value: 'ProcessManagement', disabled: false },
  { id: 3, value: 'AIMSManagement', disabled: false },
  { id: 4, value: 'ProcessTemplateManagement', disabled: false },
  { id: 5, value: 'FactoryScheduler', disabled: false },
  { id: 6, value: 'ProductManagement', disabled: false },
  { id: 7, value: 'TeplarPrintManagement', disabled: false },
  { id: 8, value: 'TrayManagement', disabled: false },
  { id: 10, value: 'KishuManagement', disabled: false },
  { id: 11, value: 'DimensionManagement', disabled: false },
  { id: 12, value: 'CheckItemManagement', disabled: false },
];

export const FactoryAdminModuleOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 1, value: 'UserManagement', disabled: false },
  { id: 3, value: 'AIMSManagement', disabled: false },
  { id: 4, value: 'ProcessTemplateManagement', disabled: false },
  { id: 5, value: 'FactoryScheduler', disabled: false },
  { id: 6, value: 'ProductManagement', disabled: false },
  { id: 7, value: 'TeplarPrintManagement', disabled: false },
  { id: 8, value: 'TrayManagement', disabled: false },
  { id: 10, value: 'KishuManagement', disabled: false },
  { id: 11, value: 'DimensionManagement', disabled: false },
  { id: 12, value: 'CheckItemManagement', disabled: false },
];

export const TeplarLabelOptions: any[] = [
  { label: 'Auto', value: 0 },
  { label: 'Manual', value: 1 },
];

export const kishuMarkOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: '♠️', disabled: false },
  { id: 1, value: '♥️', disabled: false },
  { id: 2, value: '♦️', disabled: false },
  { id: 3, value: '♣️', disabled: false },
  { id: 4, value: '★', disabled: false },
  { id: 5, value: '✿', disabled: false },
  { id: 6, value: '✪', disabled: false },
  { id: 7, value: '☾', disabled: false },
  { id: 8, value: '♪', disabled: false },
  { id: 9, value: '♬', disabled: false },
  { id: 10, value: '❉', disabled: false },
  { id: 11, value: '♕', disabled: false },
  { id: 12, value: '♘', disabled: false },
  { id: 13, value: '⚓', disabled: false },
  { id: 14, value: '♨', disabled: false },
  { id: 15, value: '⚅', disabled: false },
  { id: 16, value: 'Ω', disabled: false },
  { id: 17, value: 'Ψ', disabled: false },
  { id: 18, value: 'Σ', disabled: false },
  { id: 19, value: 'Λ', disabled: false },
];

export const UserTypeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'SuperAdministrator', disabled: false },
  { id: 1, value: 'DID Manager', disabled: false },
  { id: 2, value: 'Factory Admin', disabled: false },
  { id: 3, value: 'Factory Manager', disabled: false },
  { id: 4, value: 'Operator Leader', disabled: false },
  { id: 5, value: 'Factory Production Manager', disabled: false },
  { id: 6, value: 'Operator', disabled: false },
];

export const ViewTypeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Vertical', disabled: false },
  { id: 1, value: 'Horizontal', disabled: false },
];

export const dimensionType: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'Info', disabled: false },
  { id: 1, value: 'Check', disabled: false },
  // { id: 2, value: 'Print', disabled: false },
];

export const materialClassificationOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: 0, value: 'B', disabled: false },
  { id: 1, value: 'F', disabled: false },
];
